export const phoneRegex = new RegExp(
  /^(\(\+\d{1,3}\))?\d{2,5}-\d{1,4}-\d{1,4}$/,
)

export const alphanumericRegex = new RegExp(/^[a-zA-Z0-9 ]*$/)
